import axiosInstance from './axiosApis';

const loadOptions = async (search, prevOptions, {endPoint, page=1, dependent, dependentValue, custom, labelName='name' }) => {
    const filter = dependentValue ? `&${dependent}=${dependentValue}`: '';
    let options = [];
    let hasMore = false;
    let additional = {
        endPoint: endPoint,
        page: page,
        dependent: dependent,
        dependentValue: dependentValue,
        labelName: labelName
    };
    if (  ( endPoint !== false) && ( dependentValue === undefined || dependentValue && true) ){
        const response = await axiosInstance.get(`${endPoint}?search=${search}${filter}`);
        var optionData = {}
        options = await response.data.data.map(result => {
            var label = labelName.split(",");
            return {
                        value: result.id,
                        label: label.length === 1 ?  eval('result.' + labelName) : (eval('result.' + label[0])+" - "+eval('result.' + label[1])),
                        code : result.is_entrance_exam || ""
                    }
        })       
    }
    if( custom !== undefined ){
        return {
            options: optionData,
            hasMore:  hasMore,
            additional: additional
        };
    }else{
        let filteredOptions;
        if (!search) {
          filteredOptions = options;
        } else {
          const searchLower = search.toLowerCase();
          filteredOptions = options.filter(res => {
             var data = res.label.toLowerCase().includes(searchLower);
             return data
          })
        }
        return {
            options: filteredOptions,
            hasMore:  hasMore,
            additional: additional
        };
    }
};

export default loadOptions;
